// 認証コード
export const AUTH_TYPE = [
  { text: "スタンプカード", value: "0" },
  { text: "ポイントカード", value: "1" },
  { text: "クーポン", value: "2" },
  { text: "デジタルチケット", value: "3" }
];
